import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-grid-project-commits',
  templateUrl: './grid-project-commits.component.html',
  styleUrls: ['./grid-project-commits.component.scss']
})
export class GridProjectCommitsComponent implements OnInit {

  @Input() data: any;
  @Input() commitCountByUser: any;
  cols: any[];
  @Input() commitFilter: any;
  gridData: any;
  totalcount: any;
  chartData: any;
  additions: any;
  deletions: any;
  total: any;
  selectedUserEmail: any;
  totalRecords: any;

  constructor() {
    this.cols = [
      { field: 'position', header: 'S.No' },
      { field: 'author_email', header: 'Author Email' },
      { field: 'author_name', header: 'Author Name' },
      { field: 'authored_date', header: 'Authored Date' },
      { field: 'committer_email', header: 'Committer Email' },
      { field: 'committer_name', header: 'Committer Name' },
      // { field: 'stats', header: 'Commits' },
      // { field: 'title', header: 'Commit Title' },
      { field: 'message', header: 'Commit Message' }
    ];
  }

  ngOnInit() {
    this.totalRecords = this.data.length;
    let chartLabels = [];
    let chartData = [];
    this.commitCountByUser.forEach(element => {
      chartLabels.push(element.user);
      chartData.push(element.commitCount);
    });

    this.chartData = {
      labels: chartLabels,
      datasets: [
        {
          data: chartData,
          backgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56',
            '#FAEBD7',
            '#C70039',
            '#581845',
            '#6133FF',
            '#33FF6B',
            '#008080',
            '#00FFFF',
            '#FFC0CB',
            '#FF7F50',
            '#800000',
            '#333300'
          ],
          hoverBackgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56',
            '#FAEBD7',
            '#C70039',
            '#581845',
            '#6133FF',
            '#33FF6B',
            '#008080',
            '#00FFFF',
            '#FFC0CB',
            '#FF7F50',
            '#800000',
            '#333300'
          ]
        }]
    };
    this.totalcount = this.data.length;

    this.detailView('');

  }

  filterApplied(data) {
    this.totalcount = data.filteredValue.length;
  }

  detailView(event) {
    let selectedUser = [];
    if (event != '') {
      selectedUser = this.commitCountByUser.filter(x => x.user == event.element._model.label);
    }
    this.additions = selectedUser.length > 0 ? selectedUser[0].additions : this.commitCountByUser[0].additions;
    this.deletions = selectedUser.length > 0 ? selectedUser[0].deletions : this.commitCountByUser[0].deletions;
    this.total = selectedUser.length > 0 ? selectedUser[0].total : this.commitCountByUser[0].total;
    this.selectedUserEmail = (event != '' ? event.element._model.label : this.commitCountByUser[0].user).replace(/@[^@]+$/, '');
  }


}
